var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.dados.loading,
          expression: "dados.loading"
        }
      ],
      style: _vm.dados.loading ? "min-height: 100px;" : ""
    },
    [
      _vm.hasAnyPratica || _vm.dados.hasOutros
        ? _c(
            "div",
            [
              _c(
                "el-collapse",
                { on: { change: _vm.handleDownloadFotos } },
                [
                  _vm.praticas.praticaSustentavelPRPD
                    ? _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title:
                              "Práticas para Recuperação de Pastagens Degradadas (PRPD)",
                            name: "PRPD"
                          }
                        },
                        [
                          _c("GridFotos", {
                            attrs: { fotos: _vm.fotos["PRPD"] }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.praticas.praticaSustentavelSPDG &&
                  _vm.praticas.praticaSustentavelSPDG.length
                    ? _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title: "Sistema de Plantio Direto de Grãos (SPDG)",
                            name: "SPDG"
                          }
                        },
                        [
                          _c("GridFotos", {
                            attrs: { fotos: _vm.fotos["SPDG"] }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.praticas.praticaSustentavelSPDH &&
                  _vm.praticas.praticaSustentavelSPDH.length
                    ? _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title:
                              "Sistema de Plantio Direto de Hortaliças (SPDH)",
                            name: "SPDH"
                          }
                        },
                        [
                          _c("GridFotos", {
                            attrs: { fotos: _vm.fotos["SPDH"] }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.praticas.praticaSustentavelILPF
                    ? _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title:
                              "Integração Lavoura-Pecuária-Floresta (ILPF)",
                            name: "ILPF"
                          }
                        },
                        [
                          _c("GridFotos", {
                            attrs: { fotos: _vm.fotos["ILPF"] }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.praticas.praticaSustentavelSAF
                    ? _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title: "Sistemas Agroflorestais (SAF)",
                            name: "SAF"
                          }
                        },
                        [
                          _c("GridFotos", {
                            attrs: { fotos: _vm.fotos["SAF"] }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.praticas.praticaSustentavelFP
                    ? _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title: "Florestas Plantadas (FP)",
                            name: "FP"
                          }
                        },
                        [
                          _c("GridFotos", { attrs: { fotos: _vm.fotos["FP"] } })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.praticas.praticaSustentavelMRPA
                    ? _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title:
                              "Manejo de Resíduos da Produção Animal (MRPA)",
                            name: "MRPA"
                          }
                        },
                        [
                          _c("GridFotos", {
                            attrs: { fotos: _vm.fotos["MRPA"] }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.praticas.praticaSustentavelTI
                    ? _c(
                        "el-collapse-item",
                        {
                          attrs: {
                            title: "Terminação intensiva (TI)",
                            name: "TI"
                          }
                        },
                        [
                          _c("GridFotos", { attrs: { fotos: _vm.fotos["TI"] } })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.dados.hasOutros
                    ? _c(
                        "el-collapse-item",
                        { attrs: { title: "Outros", name: "OUTROS" } },
                        [
                          _c("GridFotos", {
                            attrs: { fotos: _vm.fotos["OUTROS"] }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _c("div", [
            _c("span", [_vm._v("Nenhuma foto foi anexada ao cadastro.")])
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6151e59a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6151e59a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Galeria/Galeria.vue
// module id = null
// module chunks = 